export const environment = {
    production: true,
    apiOrigin: 'https://dlidlr.apcrda.org',
    chatbotOrigin: 'http://localhost:4902'
};
